import ContentLayout from '@/layouts/content-layout'
import ClipCategoriesView from '@/sections/clip-categories/view/clip-categories-view'

export default function ClipCategoriesPage() {
  return (
    <ContentLayout title="หมวดหมู่คลิป">
      <ClipCategoriesView />
    </ContentLayout>
  )
}
